module.exports = __webpack_public_path__ + "img/02-kuaishu.0540055a.png";